export class DeviceRequest {
  id = "";
  name = "";
  serialNo = "";
  description = "";
  status = "";
}
